<template lang="pug">
  section.is-somos(ref="somos")
    .container
      .columns.has-text-centered.content
        .column.is-12
          h2.title.has-text-dark.is-size-2  ¿Quiénes somos?
      .columns
        .column.has-text-centered
          div.is-horizontal-center
            figure.image
              img#logoDucter(src="@/assets/ducter_color.png")
      .columns.has-text-centered
        .column.is-12
          p.h3.is-size-4 Somos una empresa dedicada al recibo, almacenamiento, transporte y entrega de gas L.P. de la más alta calidad.
</template>

<script>
export default {
  name: "Somos",
  props: {
    seccionSel: {
      type: String,
      default: "",
    },
  },
  watch: {
    seccionSel() {
      if (this.seccionSel === "somos") {
        this.$refs["somos"].scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
.is-somos {
  margin-top: 50px;
  margin-bottom: 50px;
}

.is-horizontal-center {
  display: flex !important;
  justify-content: center;
}

#logoDucter {
  max-width: 300px;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/landing_Componentes/Somos.vue